var _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    fill: "url(#paint0_linear_2312_11)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5794 27.9343C36.1443 27.6219 35.5701 27.5791 35.0957 27.823C34.6199 28.0677 34.3203 28.5578 34.3203 29.0928V61.9061C34.3203 62.4411 34.6199 62.9319 35.0957 63.1759C35.3011 63.2807 35.5244 63.3328 35.747 63.3328C36.0402 63.3328 36.3326 63.2422 36.5794 63.0646L59.4061 46.6579C59.7792 46.3897 60.0004 45.9588 60.0004 45.4995C60.0004 45.0401 59.7792 44.6092 59.4061 44.341L36.5794 27.9343Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2312_11",
    x1: 45,
    y1: 0,
    x2: 45,
    y2: 90,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B98A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E689C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/play-button.20b206d2384bffbe8edd2cbdf04d939c.svg";
export { ForwardRef as ReactComponent };